<script>
	import Select from '@/pages/components/form/input-only/select.vue';
	import formInput from "@/mixins/shared/formInput";
	import icons from '@/mixins/shared/icons'

	export default {
		mixins: [formInput, icons],
		components: {
			Select
		},
		props: {
			showBootstrapMessage: {
				type: Boolean,
				default: true,
			},
			placeholder: {
				type: String,
				required: false,
				default: '',
			}
		},
		data() {
			return {
				currentValueLabel: null
			}
		},
		mounted() {
			this.getCurrentValueLabel();
		},
		methods: {
			getCurrentValueLabel() {
				if (!this.modelValue) {
					return;
				}
				this.currentValueLabel = this.getIconNameFromClass(this.modelValue);
			},

			alterSelectSettings(settings) {
				settings.minimumInputLength = 0;
				settings.templateResult = this.formatIcon;
				return settings;
			},

			formatIcon(icon) {
				if (!icon.id) {
					return icon.text
				};

				return $(`
					<span class="d-flex align-items-center">
						<i style="font-size: 1.5em" class="lh-1 pe-2 ${icon.id}"></i>
						<span>${icon.text}</span>
					</span>
				`);
			}
		}
	};
</script>

<template>
	<div class="input-group">
		<span class="input-group-text">
            <i class="lh-1" :class="modelValue || placeholder"></i>
		</span>

		<div class="d-flex align-items-center flex-grow-1" :class="{'no-rounded-start' : true, 'no-rounded-end' : $slots.addonafter}">
			<Select
				group-classes="flex-grow-1"
				v-bind="$attrs"
				:id="renderedId"
				:name="name"
				:model-value="modelValue"
				:ajax-url="route('api.v1.icons.index')"
				:alter-settings="alterSelectSettings"
				:current-value-label="currentValueLabel"
				:placeholder="getIconNameFromClass(placeholder)"
				@update:modelValue="changeModelValueTo" />
		</div>

		<span class="input-group-text" v-if="$slots.addonafter">
			<slot name="addonafter" />
		</span>
	</div>

	<div class="input-description mt-2" v-if="showBootstrapMessage">
		De bovenstaande icoontjes zijn afkomstig van <a target="_blank" href="https://icons.getbootstrap.com/">getbootstrap.com</a>. Via deze website vind je een volledig overzicht van alle beschikbare iconen.
	</div>

	<div v-if="$slots.descriptionbottom" class="input-description mt-2">
		<slot name="descriptionbottom" />
	</div>

	<label v-if="hasError" class="text-danger mt-2 small">{{ this.form.errors[this.name] }}</label>
</template>